export const state = {
  fuels: [],
  fuel_item: [
    {
      fill_date: "",
      truck_id: "",
      description: "",
      litre: "",
      rate_per_litre: "",
      total_price: "",
      date_loading: "",
      consignee_id: "",
      station_id: "",

    }
  ]
};
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/fuels/state.js